<template>
  <b-container class="bv-example-row">
    <b-row>
      <b-col>
        <b-alert
          show
          variant="light"
          class="alert alert-custom alert-white alert-shadow fade show gutter-b"
        >
          <div class="alert-icon">
            <span class="svg-icon svg-icon-lg">
              <inline-svg src="media/svg/icons/Tools/Compass.svg" />
            </span>
          </div>
          <div class="alert-text">
            You are seeing this tracker device
          </div>
        </b-alert>
      </b-col>
    </b-row>
    <b-row>
            <b-col>
                <SuitchMapWidget :device="current_device"/>
            </b-col>
        </b-row>
    <b-row>
      <b-col>
        <SuitchBatteryWidget :device="current_device" :limitBatteryDate="limitBatteryDate" findMyType="tracker"/>
      </b-col>
      <b-col>
        <SuitchTrackerStatusWidget :device="current_device"/>
        <br />
        <br />

        <SuitchDetailsWidget :device="current_device"/>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6"> </b-col>
      <b-col cols="4">
        <!-- more information here -->
      </b-col>
    </b-row>
  </b-container>

  <!--end::Example-->
</template>

<script>
import { FETCH_SINGLE_DEVICE } from "@/core/services/store/devices.module";
import SuitchTrackerStatusWidget from "@/view/content/widgets/suitch/suitch-tracker-status-widget.vue";
import SuitchMapWidget from "@/view/content/widgets/suitch/suitch-map-widget.vue";
import SuitchDetailsWidget from "@/view/content/widgets/suitch/suitch-details-widget.vue";
import SuitchBatteryWidget from "@/view/content/widgets/suitch/suitch-battery-widget.vue";


export default {
  data() {
    return {
      limitBatteryDate:"",
      global_wizard: {},
      current_device: null,
    };
  },
  
  computed: {
  },

  components: {
    SuitchTrackerStatusWidget,
    SuitchDetailsWidget,
    SuitchMapWidget,
    SuitchBatteryWidget,
  },

  methods: {
    
   
  },
  mounted() {
    // console.log("route:",this.$route.params);
    const device_token = this.$route.params.token;

    this.$store
      .dispatch(FETCH_SINGLE_DEVICE, { device_token })
      // go to which page after successfully login
      .then((data) => {
        // download devices list
        this.current_device = data;
        this.limitBatteryDate = new Date(data.created_at);
      });
    },
  };
</script>
